import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  setCurrentEquipmentStatus,
  setOriginalCurrentEquipmentStatus,
} from '~/store/dispatch/actions';
import { usePlatformConfigurationAuth } from '~/services/platformConfiguration';
import { calculateDurationBytimestamp, formatTimestamp } from '~/utils/moment';
import { generateDailyPassword, getPasswordExpirationTime } from '~/utils/hash';

export const useEquipmentStatusItem = (equipment) => {
  const dispatch = useDispatch();

  const checkboxState = usePlatformConfigurationAuth('dispatch_equipmentstatus_checkbox') || '0';

  const handleSelectItem = useCallback(() => {
    const nowTimestamp = formatTimestamp();
    const newEquipment = {
      ...equipment,
      sent_from_tablet: checkboxState.value === '1',
      duration: calculateDurationBytimestamp(equipment?.start_timestamp),
      unlock_password: generateDailyPassword(equipment?.id_equip),
      unlock_password_expired: getPasswordExpirationTime(),
      start_timestamp: nowTimestamp,
    };
    dispatch(
      setCurrentEquipmentStatus(newEquipment),
    );

    dispatch(setOriginalCurrentEquipmentStatus(newEquipment));
  }, [dispatch, equipment, checkboxState]);

  return {
    handleSelectItem,
  };
};
